import type { LcvModel } from '@/types/tis-cms/types';

export const compareLocaleString = (
  a: string = '',
  b: string = '',
  lang?: Intl.LocalesArgument,
  options?: Intl.CollatorOptions
) => a.localeCompare(b, lang, options);

export const sortModel = (data: LcvModel[], modelDocumentIds: string[]) => {
  const idToObjMap = new Map(data.map((obj) => [obj.documentId, obj]));
  const sortedArray = modelDocumentIds.map((documentId) =>
    idToObjMap.get(documentId)
  );

  return sortedArray.filter((obj) => obj);
};
